const parseFechaLocal = (fechaStr) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,7}))?)?$/.exec(
    fechaStr
  );
  if (!match) return null;
  const [, y, m, d, hh, mm, ss = "0", ms = "0"] = match;
  const msNormalizado = ms.padEnd(3, "0").slice(0, 3);
  return new Date(
    Number(y),
    Number(m) - 1,
    Number(d),
    Number(hh),
    Number(mm),
    Number(ss),
    Number(msNormalizado)
  );
};

export const formatFechaSegura = (fechaStr) => {
  if (!fechaStr) return 'Sin fecha';
  const fechaNormalizada = String(fechaStr).trim();

  // Mostrar exactamente la fecha que llega desde la query
  if (fechaNormalizada) return fechaNormalizada;

  const tieneZonaHoraria = /[zZ]|[+-]\d{2}:?\d{2}$/.test(fechaNormalizada);
  const fecha = tieneZonaHoraria ? new Date(fechaNormalizada) : parseFechaLocal(fechaNormalizada);
  if (!fecha || isNaN(fecha.getTime())) return 'Fecha inválida';
  return fecha.toLocaleString('es-CO');
};
